import { render, staticRenderFns } from "./Computers.vue?vue&type=template&id=1dfa87a8"
import script from "../services/Computers.js?vue&type=script&lang=js&external"
export * from "../services/Computers.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports